export default __webpack_public_path__ + "static/media/logo.05426b43.png";